import React from "react";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import "./ModalContainer.css";
import ChatWindow from "../ChatComponents/ChatWindow";

const ModalContainer = ({
  isConfirmed,
  onClick,
  onOpen,
  onClose,
  onMinimize,
  config,
}) => (
  <div className="modal-container" onClick={onClick} >
    {
      isConfirmed ? (
        <ChatWindow
          onClose={onClose}
          onMinimize={onMinimize}
          inputPlaceholder={config.text ? config.text.inputPlaceholder : undefined}
          config={config}
        />
      ) : (
        <ConfirmDialog
          onOptInClick={onOpen}
          onOptOutClick={onClose}
          optInText={config.text ? config.text.optInText : undefined}
          optOutText={config.text ? config.text.optOutText : undefined}
          headerText={config.text ? config.text.headerText : undefined}
          subheaderText={config.text ? config.text.subheaderText : undefined}
        />
      )
    }
  </div>
);

export default ModalContainer;
